import axios from "axios";
import { ElMessage, ElLoading } from "element-plus";
import store from "@/store";
import router from "@/router";

const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_URL,
  // 超时
  timeout: 1000000,
});

let loadingInstance; // ElLoading 实例

// request拦截器
service.interceptors.request.use(
  (config) => {
    // 从store获取token（store已从localStorage恢复状态）
    if (store.state.token) {
      config.headers["Authorization"] = store.state.token;
    }
    // 显示loading
    loadingInstance = ElLoading.service({
      fullscreen: true,
      text: "拼命加载中...",
    });
    return config;
  },
  (error) => {
    // 隐藏loading
    if (loadingInstance) {
      loadingInstance.close();
    }
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (res) => {
    // 隐藏loading
    if (loadingInstance) {
      loadingInstance.close();
    }
    // 未设置状态码则默认成功状态
    const code = res.data.code;
    if (code === 0) {
      return Promise.resolve(res.data);
    } else if (code === 401) {
      console.log(res, '登录信息已失效，请重新登录');
      // 使用logout action统一处理退出登录
      store.dispatch('logout').then(() => {
        router.replace('/');
        ElMessage.error("登录信息已失效，请重新登录");
      });
      return Promise.reject(res.data);
    } else if (code === 500) {
      ElMessage.error(res.data.msg || '服务器错误');
      return Promise.reject("error");
    } else if (code === 601) {
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  (error) => {
    console.log("err" + error);
    // 隐藏loading
    if (loadingInstance) {
      loadingInstance.close();
    }
    
    // 处理网络错误或服务器错误
    let errorMsg = '请求失败';
    if (error.response) {
      // 服务器返回错误状态码
      switch (error.response.status) {
        case 401:
          // 未授权，清除登录状态
          store.dispatch('logout').then(() => {
            router.replace('/');
            ElMessage.error('登录已过期，请重新登录');
          });
          break;
        case 404:
          errorMsg = '请求的资源不存在';
          break;
        case 500:
          errorMsg = '服务器内部错误';
          break;
        default:
          errorMsg = error.response.data?.msg || '请求失败';
      }
      ElMessage.error(errorMsg);
    } else if (error.request) {
      // 请求已发出但没有收到响应
      ElMessage.error('网络连接失败，请检查网络');
    } else {
      // 请求配置出错
      ElMessage.error('请求配置错误');
    }
    return Promise.reject(error);
  },
);

export default service;
